<form>
    <div class="condition-container">
        <div class="condition-header">
            <h4 class="red-title">{{ groupId }} - {{ conditionType.label }}</h4>
            <ng-container *ngIf="hasLowerGroups">
                <span class="condition-header-separator" aria-hidden="true"></span>
                <div class="condition-category-info">
                    <mat-icon class="material-icons" aria-hidden="true">error</mat-icon>
                    <span>Autres catégories bloquées par les groupes suivants.</span>
                </div>
            </ng-container>
        </div>

        <div class="inputs-container">
            <!-- Category -->
            <div class="tv-container-select-white-rect-extensible">
                <mat-form-field>
                    <mat-label>Catégorie de la négociation</mat-label>
                    <mat-select panelClass="tv-custom-always-visible-scroll-bar" [formControl]="categoryTypeFormControl">
                        <mat-option *ngFor="let category of categoryTypeList" class="tv-ns-select-option" [value]="category">
                            {{ category.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Search Item -->
            <div class="tv-rect-input-extensible">
                <mat-form-field>
                    <mat-label>{{ hasNoCategoryItems ? 'Aucun élément pour cette catégorie' : 'Rechercher' }}</mat-label>
                    <input
                        class="tv-ns-select-option"
                        type="text"
                        aria-label="Number"
                        matInput
                        [formControl]="searchFormControl"
                        [matAutocomplete]="auto" />
                    <mat-autocomplete class="tv-custom-always-visible-scroll-bar" #auto="matAutocomplete" [displayWith]="displayItem">
                        <mat-option
                            *ngFor="let item of filteredItemList | async; trackBy: trackByItemId"
                            class="tv-ns-select-option"
                            [value]="item">
                            {{ item.name }} ({{ item.id }})
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <!-- List Button-->
            <button
                type="button"
                [disabled]="isFilteredItemListFill()"
                (click)="listAllOptions()"
                class="tv-round-icon-button-icon-medium-light-blue">
                <mat-spinner *ngIf="isItemLoading; else listIcon" diameter="20" class="light-spinner"></mat-spinner>
                <ng-template #listIcon>
                    <mat-icon>list</mat-icon>
                </ng-template>
            </button>

            <!-- Delete condition button -->
            <button type="button" class="tv-round-icon-button-icon-medium-light-blue" (click)="removeCondition()">
                <mat-icon class="material-icons-outlined">delete</mat-icon>
            </button>

        </div>

        <div *ngIf="chosenItemList.length > 0" class="conditions-table-container">
            <div class="conditions-table-scroll tv-custom-always-visible-scroll-bar">
                <table mat-table [dataSource]="chosenItemList" class="tv-ns-mat-table tv-ns-large-mat-table conditions-table">
                    <ng-container matColumnDef="category">
                        <th mat-header-cell *matHeaderCellDef>Catégorie de négo ({{ conditionCategoryCount }})</th>
                        <td mat-cell *matCellDef="let row">
                            <span class="condition-cell-text" [attr.title]="row.itemType?.name">{{ row.itemType?.name }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Nom ({{ chosenItemList.length }})</th>
                        <td mat-cell *matCellDef="let row">
                            <span class="condition-cell-text" [attr.title]="row.item.name">{{ row.item.name }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>Numéro</th>
                        <td mat-cell *matCellDef="let row">
                            <span class="condition-cell-text" [attr.title]="row.item.id">{{ row.item.id }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="remove">
                        <th mat-header-cell *matHeaderCellDef aria-label="Supprimer"></th>
                        <td mat-cell *matCellDef="let row" class="mat-cell-center-align">
                            <span
                                class="condition-remove-button-wrapper"
                                matTooltip="Suppression bloquée par les groupes suivants."
                                matTooltipClass="custom-tv-tooltip"
                                [matTooltipDisabled]="!isLastItemRemovalDisabled"
                                [attr.tabindex]="isLastItemRemovalDisabled ? 0 : null">
                                <button
                                    type="button"
                                    class="tv-icon-button-s-transparent"
                                    [disabled]="isLastItemRemovalDisabled"
                                    [attr.aria-label]="'Supprimer ' + row.item.name"
                                    (click)="removeItem(row)">
                                    <mat-icon class="material-icons-outlined condition-remove-icon">delete</mat-icon>
                                </button>
                            </span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="conditionColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: conditionColumns"></tr>
                </table>
            </div>
        </div>
    </div>
</form>
